/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

export interface WithinDistanceActionArgs {
  distance: number;
}

export interface WithinDistanceResultData {
}

export interface WithinDistanceActionStateData {
}

function createBaseWithinDistanceActionArgs(): WithinDistanceActionArgs {
  return { distance: 0 };
}

export const WithinDistanceActionArgs = {
  encode(message: WithinDistanceActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.distance !== 0) {
      writer.uint32(13).float(message.distance);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WithinDistanceActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWithinDistanceActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 13) {
            break;
          }

          message.distance = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WithinDistanceActionArgs {
    return { distance: isSet(object.distance) ? globalThis.Number(object.distance) : 0 };
  },

  toJSON(message: WithinDistanceActionArgs): unknown {
    const obj: any = {};
    if (message.distance !== 0) {
      obj.distance = message.distance;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WithinDistanceActionArgs>, I>>(base?: I): WithinDistanceActionArgs {
    return WithinDistanceActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WithinDistanceActionArgs>, I>>(object: I): WithinDistanceActionArgs {
    const message = createBaseWithinDistanceActionArgs();
    message.distance = object.distance ?? 0;
    return message;
  },
};

function createBaseWithinDistanceResultData(): WithinDistanceResultData {
  return {};
}

export const WithinDistanceResultData = {
  encode(_: WithinDistanceResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WithinDistanceResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWithinDistanceResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): WithinDistanceResultData {
    return {};
  },

  toJSON(_: WithinDistanceResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<WithinDistanceResultData>, I>>(base?: I): WithinDistanceResultData {
    return WithinDistanceResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WithinDistanceResultData>, I>>(_: I): WithinDistanceResultData {
    const message = createBaseWithinDistanceResultData();
    return message;
  },
};

function createBaseWithinDistanceActionStateData(): WithinDistanceActionStateData {
  return {};
}

export const WithinDistanceActionStateData = {
  encode(_: WithinDistanceActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WithinDistanceActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWithinDistanceActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): WithinDistanceActionStateData {
    return {};
  },

  toJSON(_: WithinDistanceActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<WithinDistanceActionStateData>, I>>(base?: I): WithinDistanceActionStateData {
    return WithinDistanceActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WithinDistanceActionStateData>, I>>(_: I): WithinDistanceActionStateData {
    const message = createBaseWithinDistanceActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
